import React from 'react';

function Home(props) {
    return (
        <div>
            this is home
        </div>
    );
}

export default Home;